<div class="modal-body">
    <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="wrapper">
        <img [src]="imgUrl" class="w-100"
             default="./assets/images/default/default-image-w300.webp">
    </div>
</div>
